<template>
<m-pageframe
    title="Admin: Secrets"
>
<v-container
    fluid
>
    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>

            <v-list>

                <v-list-item
                    v-for="(item, index) in $rc.enumValues('secret_type', false)"
                    :key="'type_'+index"
                    v-on:click="onClickProvideSecret(item.value)"
                >
                    <v-list-item-title>Provide {{item.text}}...</v-list-item-title>
                </v-list-item>

            </v-list>
        </v-menu>
    </v-text-field>



    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >

        <template v-slot:item.time_create_date="{ item }">
            {{$rc.pretty(item.time_create, 'date')}}
        </template>

         <template v-slot:item.time_create_time="{ item }">
            {{$rc.pretty(item.time_create, 'time')}}
        </template>

        <template v-slot:item.assigned_to_tags="{ item }">
            <m-rc-tag-display
                :value="item.rc_tags"
            />
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu
                bottom
                offset-y
            >

            <template v-slot:activator="{ on }">

                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>

            </template>

            <v-list>
                <v-list-item
                    v-on:click="onClickAccess(item)"
                >
                    <v-list-item-title>Access...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickAssign(item)"
                >
                    <v-list-item-title>Assign to me</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickEditNote(item)"
                >
                    <v-list-item-title>Edit Note...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickDelete(item)"
                >
                    <v-list-item-title>Delete...</v-list-item-title>
                </v-list-item>


            </v-list>

            </v-menu>
        </template>

    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,
            secret_type_filter: null,
            results: [],

            headers: [
                { text: 'Date', value: 'time_create_date'},
                { text: 'Time', value: 'time_create_time'},
                { text: 'Type', value: 'type'},
                { text: 'Organization', value: 'for_organization_label'},
                { text: 'First Name', value: 'first_name'},
                { text: 'Last Name', value: 'last_name'},
                { text: 'Assigned To', value: 'assigned_to_tags' },
                { text: 'Note', value: 'note'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        // Check for URL query parameters
        if (this.$route.query.search) {
            this.full_text = this.$route.query.search;
        }
        if (this.$route.query.type) {
            this.secret_type_filter = this.$route.query.type;
        }

        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        doUpdate()
        {
            let params = {
                'encrypted_secret': { type: 'is-not-blank' },
                'sort': 'time_create:desc',
                'full_text': this.full_text,
            };

            // Add secret type filter if specified
            if (this.secret_type_filter) {
                params.type = this.secret_type_filter;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/secrets',

                'params' : params,

                'on_success': (data) => {
                        this.results = data.results;
                    },

                'on_error': 'Unable to search secrets',
            });
        },

        onClickAccess(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/secrets/access/:secret_id',

                'params' : {
                        'secret_id': item.secret_id,
                    },

                'on_success': (data) => {
                        this.$rc.copy_code_dialog({
                            'title': 'Secret',
                            'object': data.secret,
                        });
                    },

                'on_error': 'Unable to access secret',
            });
        },

        onClickDelete(item)
        {
            this.$rc.confirm({
                'title': 'Confirm Delete',
                'body': 'Are you sure that you would like to permenantly delete this secret?',
                'btn_text_ok': 'Delete',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doDelete(item);
                },
            });
        },

        doDelete(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'DELETE: /api/v1/secrets/:secret_id',

                'params' : {
                        'secret_id': item.secret_id,
                    },

                'on_success': (data) => {
                        this.doUpdate();
                    },

                'on_error': 'Unable to delete secret',
            });
        },

        onClickProvideSecret(secret_type)
        {
            window.open(this.$router.resolve({
                'name': 'red-chirp-provide-secret',
                'params' : {
                    'secret_type': secret_type,
                }
            }).href, '_blank');
        },

        onClickAssign(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'POST: /api/v1/secrets/:secret_id/assign',

                'params' : {
                        'secret_id': item.secret_id,
                    },

                'on_success': (data) => {
                        this.doUpdate();
                    },

                'on_error': 'Unable to assign secret',
            });
        },

        onClickEditNote(item)
        {
            this.$rc.prompt({
                'title' : 'Note',
                'label' : 'Note',
                'value' : item.note,
                'allow_blank': true,
                'after_prompt' : (value) => {
                    this.doEditNote(item, value);
                }
            });
        },

        doEditNote(item, new_note)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'POST: /api/v1/secrets/:secret_id/note',

                'params' : {
                        'secret_id': item.secret_id,
                        'note': new_note
                    },

                'on_success': (data) => {
                        this.doUpdate();
                    },

                'on_error': 'Unable to edit note',
            });

        }
    },
}
</script>

<style lang="scss" scoped>
</style>